import React from "react";

import styles from "./MainWrapper.module.scss";

export function MainWrapper({ children }) {
  return <div className={styles.main_wrapper}>{children}</div>;
}
